/**
 * ============================================================================
 * Month-name date labels. ONE COPY OF THE MONTH ARRAY (D-106).
 * ============================================================================
 *
 * There were two before this file: `awardDate` in `Achievements.tsx` and
 * `longDate` in `CertificateShowcase.tsx`, each with its own twelve-string
 * array. Adding the Letters of Appreciation section would have written a third,
 * which is the point at which D-102's rule applies — two surfaces drawing one
 * thing diverge, and the fix is one implementation rather than one correction.
 *
 * NEVER `new Date(iso)`. `new Date("2024-01-31")` is parsed as UTC midnight and
 * renders as the 30th anywhere west of Greenwich; `new Date("2024-12")` renders
 * as November. Both are silent, both are wrong by one, and both have bitten
 * this repository — `formatMonth` in `constants/experience.ts` carries the
 * same warning. The parsing here is a `split` and an index lookup, which cannot
 * have a timezone.
 */
const MONTHS: readonly string[] = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
];

/**
 * "2024-12" -> "December 2024". A bare "2018" is returned unchanged.
 *
 * The year-only pass-through is load-bearing: `awards.json` carries two
 * martial-arts entries dated by year alone, and inventing a month for them
 * would be D-066's unsourced value in a date field.
 */
export const monthYear = (value: string): string => {
	const [year, month] = value.split("-");
	if (month === undefined) return year;
	return `${MONTHS[Number(month) - 1]} ${year}`;
};

/** "2024-01-31" -> "31 January 2024". For a date printed on a document. */
export const longDate = (iso: string): string => {
	const [year, month, day] = iso.split("-").map(Number);
	return `${day} ${MONTHS[month - 1]} ${year}`;
};
